import React from 'react';

export default function Trash() {
  return <svg width="11" height="15" viewBox="0 0 11 15" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M0.785714 13.3333C0.785714 14.25 1.49286 15 2.35714 15H8.64286C9.50714 15 10.2143 14.25 10.2143 13.3333V3.33333H0.785714V13.3333ZM11 0.833333H8.25L7.46429 0H3.53571L2.75 0.833333H0V2.5H11V0.833333Z" fill="#009ACB"/>
		</svg>
}
